// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"407":"81271900","436":"198c1915","453":"f394a27d","501":"94643f99","606":"5f9abdb0","925":"07fcbcbc"}[chunkId] + ".chunk.js";
};